/**
 * @generated SignedSource<<c032840f4622fe636050de0cf92d3ba7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DismissibleElementsMarkElementAsSeenMutation$variables = {
  key: string;
};
export type DismissibleElementsMarkElementAsSeenMutation$data = {
  readonly viewerMarkElementAsSeen: {
    readonly viewer: {
      readonly id: string;
      readonly unseenElements: ReadonlyArray<{
        readonly id: string;
        readonly key: string;
        readonly lastAcknowledgedAt: string | null;
        readonly viewsRemaining: number;
      }>;
    } | null;
  } | null;
};
export type DismissibleElementsMarkElementAsSeenMutation$rawResponse = {
  readonly viewerMarkElementAsSeen: {
    readonly viewer: {
      readonly id: string;
      readonly unseenElements: ReadonlyArray<{
        readonly id: string;
        readonly key: string;
        readonly lastAcknowledgedAt: string | null;
        readonly viewsRemaining: number;
      }>;
    } | null;
  } | null;
};
export type DismissibleElementsMarkElementAsSeenMutation = {
  rawResponse: DismissibleElementsMarkElementAsSeenMutation$rawResponse;
  response: DismissibleElementsMarkElementAsSeenMutation$data;
  variables: DismissibleElementsMarkElementAsSeenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      }
    ],
    "concreteType": "ViewerMarkElementAsSeen",
    "kind": "LinkedField",
    "name": "viewerMarkElementAsSeen",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnseenElement",
            "kind": "LinkedField",
            "name": "unseenElements",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastAcknowledgedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewsRemaining",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DismissibleElementsMarkElementAsSeenMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DismissibleElementsMarkElementAsSeenMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "749b4903ca61fe453ae79a1218a771ac",
    "id": null,
    "metadata": {},
    "name": "DismissibleElementsMarkElementAsSeenMutation",
    "operationKind": "mutation",
    "text": "mutation DismissibleElementsMarkElementAsSeenMutation(\n  $key: String!\n) {\n  viewerMarkElementAsSeen(key: $key) {\n    viewer {\n      id\n      unseenElements {\n        id\n        key\n        lastAcknowledgedAt\n        viewsRemaining\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "329d8c9d03eae7de20edba288a2e1bf7";

export default node;
